import {
  GET_EXERCISE_RECOMMENDATIONS_SUCCESS,
  GET_EXERCISE_RECOMMENDATIONS_FAIL,
  ASSIGN_EXERCISE_SUCCESS,
  UNASSIGN_EXERCISE_SUCCESS,
} from "../actions/exerciseRecommendations";

const initialState = {
  recommendations: [],
  error: null,
};

const exerciseRecommendationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_EXERCISE_RECOMMENDATIONS_SUCCESS:
      return {
        ...state,
        recommendations: action.payload.data.data,
        error: action.payload.data.msg,
      };

    case GET_EXERCISE_RECOMMENDATIONS_FAIL:
      return {
        ...state,
        recommendations: [],
        error: action.payload?.error || "Failed to fetch recommendations",
      };

    case ASSIGN_EXERCISE_SUCCESS: {
      const updatedRecommendations = state.recommendations.map((rec) => ({
        ...rec,
        details: rec.details.map((exercise) =>
          exercise.id === action.payload.data.data.id
            ? { ...exercise, is_assigned: true }
            : exercise
        ),
      }));

      return {
        ...state,
        recommendations: updatedRecommendations,
      };
    }

    case UNASSIGN_EXERCISE_SUCCESS: {
      const updatedRecommendations = state.recommendations.map((rec) => ({
        ...rec,
        details: rec.details.map((exercise) =>
          exercise.id === action.payload.data.data.id
            ? { ...exercise, is_assigned: false }
            : exercise
        ),
      }));

      return {
        ...state,
        recommendations: updatedRecommendations,
      };
    }

    default:
      return state;
  }
};

export default exerciseRecommendationsReducer;
